import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Typography,
  Snackbar,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Card,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import BartLogo from "../../components/Shared/Header/Images/BartLogo.png";
import CaratLogo from "../../components/Shared/Header/Images/c-favicon.png";
import LoginBackground from "../Login/Images/LoginBackground.jpg";

import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";

import { fetchUserProfilesService } from "../../services/dcm/userProfiles";
import { fetchAccessTokenService } from "../../services/oauth/auth";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/login");

const useStyles = makeStyles((theme) => ({
  route: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  login: {
    textAlign: "center",
    padding: "2em",
    marginTop: "2em"
  },
  subtitle: {
    marginBottom: "2em"
  },
  profiles: {
    textAlign: "center",
    padding: "1em 0.5em",
    marginTop: "2em"
  },
  bart: {
    height: 40
  },
  card: {
    minHeight: 360,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    // maxWidth: "18vw",
    padding: 30
  }
}));

export default (props) => {
  const classes = useStyles();
  const history = useHistory();

  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const [profiles, setProfiles] = useState([]);

  const [snackbarMessage, setSnackbarMessage] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const showError = (message) => {
    setLoadingProfiles(false);
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const onLoginSuccess = async (response) => {
    const code = response.code;

    try {
      setLoadingProfiles(true);
      await fetchAccessTokenService(code);
      setLoadingProfiles(false);
    } catch (e) {
      /*
       * Show Google's own reason for refusing the exchange. BartAPI passes it
       * through in the 401 body, and it is the only thing that distinguishes
       * a consent-screen problem (access_denied, admin_policy_enforced) from a
       * client mismatch (unauthorized_client) or a dead account (invalid_grant).
       */
      showError(`Could not retrieve access tokens. ${e.message || ""}`.trim());
      return;
    }

    try {
      setLoadingProfiles(true);
      let profileResponse = await fetchUserProfilesService();
      setProfiles(profileResponse);
      console.log(profileResponse);
      setLoadingProfiles(false);
    } catch (e) {
      showError(`Could not load profiles. ${e.message || ""}`.trim());
    }
  };

  const handleProfileClick = (profile) => {
    localStorage.setItem("googleProfileId", profile.profileId);
    history.push("/");
  };

  /*
   * The auth-code flow reports a rejected authorization through onError; the
   * `onFailure` this used to pass is not part of CodeClientConfig, so it was
   * forwarded to Google as an unknown key and never called. Popup-stage refusals
   * — a Testing-mode consent screen, or a Workspace app-access block — surface
   * here rather than in the token exchange.
   */
  const onLoginError = (errorResponse) => {
    console.error("Google OAuth error:", errorResponse);
    showError(
      `Login unsuccessful. ${errorResponse?.error_description ||
        errorResponse?.error ||
        ""}`.trim()
    );
  };

  const onLoginNonOAuthError = (nonOAuthError) => {
    console.error("Google non-OAuth error:", nonOAuthError);
    showError(`Login unsuccessful (${nonOAuthError?.type || "unknown"}).`);
  };

  const login = useGoogleLogin({
    onSuccess: onLoginSuccess,
    onError: onLoginError,
    onNonOAuthError: onLoginNonOAuthError,
    flow: "auth-code",
    scope: "profile email https://www.googleapis.com/auth/dfareporting https://www.googleapis.com/auth/dfatrafficking",
    /*
     * Force the account chooser. Left off, the popup silently authorizes
     * whichever Google account the browser already holds a session for, which
     * for a migrated user is their old, now-unusable identity — with no prompt
     * and no way to switch.
     *
     * accessType / prompt / approvalPrompt used to be passed here too. None of
     * them are CodeClientConfig options, so Google ignored all three; the code
     * flow is offline-capable on its own.
     */
    select_account: true
  });
  
  const loginScreen = () => {
    if (profiles.length <= 0 && !loadingProfiles) {
      return (
        <Card className={classes.card}>
          <img alt="Carat" src={CaratLogo} height="50" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Typography variant="h5" align="center">
              Welcome To Bart
            </Typography>
            <img
              alt="Bart"
              src={BartLogo}
              height="80"
              style={{ marginTop: 20 }}
            />
          </div>
          <Typography variant="body1" align="center">
            Please sign in with your Google Campaign Manager account.
          </Typography>
          {/* <GoogleLogin
            clientId="342384165232-1vjr0ia15ohspcinm3sgvhuqbb2ln6gh.apps.googleusercontent.com"
            buttonText="Sign In"
            onSuccess={onLoginSuccess}
            onFailure={onLoginFailure}
            prompt="consent"
            approvalPrompt="force"
            accessType="offline"
            responseType="code"
            scope="profile email https://www.googleapis.com/auth/dfareporting https://www.googleapis.com/auth/dfatrafficking"
            cookiePolicy={"single_host_origin"}
          /> */}
          <Button variant="contained" size="large" onClick={() => login()}>Sign in with Google</Button>
        </Card>
      );
    } else if (profiles.length > 0 && !loadingProfiles) {
      return (
        <Card
          style={{
            padding: 30,
            overflow: "visible"
          }}
        >
          <List>
            <Typography
              variant="body1"
              align="center"
              style={{ fontSize: "1.15rem", marginBottom: 15 }}
            >
              Select User Profile
            </Typography>
            {profiles.map((profile) => {
              return (
                <ListItem
                  key={profile.profileId}
                  button
                  onClick={(event) => handleProfileClick(profile)}
                >
                  <ListItemText
                    primary={profile.userName}
                    secondary={`${profile.profileId} / ${profile.accountName}`}
                  />
                </ListItem>
              );
            })}
          </List>
        </Card>
      );
    } else if (loadingProfiles) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh"
          }}
        >
          <CircularProgress />
        </div>
      );
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url("${LoginBackground}")`,
        backgroundSize: "cover"
      }}
    >
      <Container maxWidth="xs" className={classes.route}>
        {loginScreen()}
      </Container>

      {/*
        Long enough to actually read the Google error text, which is the whole
        point of surfacing it.
      */}
      <Snackbar
        autoHideDuration={15000}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity="warning">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};
